var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4268 3.35992C12.1402 3.15325 11.8135 2.99992 11.4602 2.91325C11.2268 2.84659 10.9735 2.81325 10.7202 2.81325H8.24016C7.8535 2.81325 7.82683 2.77325 7.62016 2.49992L6.68683 1.25992C6.2535 0.686585 5.9135 0.333252 4.82683 0.333252H3.28016C1.6535 0.333252 0.333496 1.65325 0.333496 3.27992V10.7199C0.333496 12.3466 1.6535 13.6666 3.28016 13.6666H10.7202C12.3468 13.6666 13.6668 12.3466 13.6668 10.7199V5.75992C13.6668 4.76659 13.1802 3.89325 12.4268 3.35992ZM8.5535 9.66659H5.44683C5.18683 9.66659 4.98016 9.45992 4.98016 9.19992C4.98016 8.94659 5.18683 8.73325 5.44683 8.73325H8.54683C8.80016 8.73325 9.0135 8.94659 9.0135 9.19992C9.0135 9.45992 8.80683 9.66659 8.5535 9.66659Z",
    fill: "#6BC0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c13cf09cf3936ae449ba86f7dad1f680.svg";
export { ForwardRef as ReactComponent };